export interface UsageItem {
	key: string;
	used: number;
	limit: number;
	remaining: number;
	percentage: number;
	unlimited: boolean;
	feature_name?: string;
	is_group?: boolean;
	feature_count?: number;
	period?: string;
	period_start?: string;
	period_end?: string;
	last_used?: string;
}

export type UsageTier = 'ok' | 'warn' | 'danger' | 'muted';

export const usageTier = (pct: number, unlimited: boolean): UsageTier => {
	if (unlimited) return 'muted';
	if (pct >= 100) return 'danger';
	if (pct >= 70) return 'warn';
	return 'ok';
};
